/* src/app/components/confirm-modal-cart/confirm-modal-cart.component.scss */
.container {
  padding: 30px;
}
.alert-icon {
  font-size: 35px;
}
h1 {
  font-size: 22px;
  font-weight: 500;
}
h2 {
  color: #949494;
  font-size: 16px;
  font-weight: 400;
}
.close {
  min-height: auto;
}
.close::part(native) {
  padding: 0;
}
.close ion-icon {
  color: black;
  font-size: 20px;
}
.delete-button > ion-icon {
  font-size: 22px;
}
/*# sourceMappingURL=confirm-modal-cart.component-522JPT5I.css.map */
